var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlateSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgSlate",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a4856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#566578"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "slateGlow",
    cx: 0.2,
    cy: 0.2,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgSlate)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#slateGlow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlateSolid);
export default __webpack_public_path__ + "static/media/slate-solid.1f503c4631ff456a13a9382ebb26693e.svg";
export { ForwardRef as ReactComponent };